var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { getSocialLoginProviderDisplayName } from "healthex-common/healthcareorganization.dtos";
import { LoginSource } from "healthex-common/heap.dtos";
import { computed, observable } from "mobx";
import { getObservableT } from "../Infra/i18next";
import { ClearAuthState } from "../Infra/Persistence";
const t = getObservableT("patients");
export class AccountLinkingViewModel {
    constructor(container) {
        this.isSandboxLogin = false;
        this.clearAuthManager = container.clearAuthManager;
        this.persistence = container.persistence;
        this.socialLoginAuthManager = container.socialLoginAuthManager;
        this.isSandboxLogin = this.persistence.isSandboxLogin();
    }
    get title() {
        return t("Verify your identity");
    }
    get subtitle() {
        var _a;
        const gfidProvider = (_a = this.socialLoginAuthManager.getAccountLinkingData()) === null || _a === void 0 ? void 0 : _a.gfidProvider;
        const providerName = gfidProvider ? getSocialLoginProviderDisplayName(gfidProvider) : "";
        return t("Your account was created using CLEAR. To continue with {{providerName}}, we need to verify it's you.", {
            providerName,
        });
    }
    get buttonLabel() {
        return t("Verify with CLEAR");
    }
    get isLoading() {
        return this.clearAuthManager.state === ClearAuthState.IN_PROGRESS;
    }
    get flipLongPressLoginButton() {
        return this.isSandboxLogin;
    }
    async verifyWithClear(sandboxMode) {
        this.persistence.setSandboxLogin(sandboxMode);
        try {
            await this.clearAuthManager.redirectToClearLoginPage(window.location.hash, LoginSource.ACCOUNT_LINKING, undefined, undefined, sandboxMode);
        }
        catch (e) {
            console.error("Failed to redirect to CLEAR login", e);
        }
    }
}
__decorate([
    observable,
    __metadata("design:type", Boolean)
], AccountLinkingViewModel.prototype, "isSandboxLogin", void 0);
__decorate([
    computed,
    __metadata("design:type", String),
    __metadata("design:paramtypes", [])
], AccountLinkingViewModel.prototype, "title", null);
__decorate([
    computed,
    __metadata("design:type", String),
    __metadata("design:paramtypes", [])
], AccountLinkingViewModel.prototype, "subtitle", null);
__decorate([
    computed,
    __metadata("design:type", String),
    __metadata("design:paramtypes", [])
], AccountLinkingViewModel.prototype, "buttonLabel", null);
__decorate([
    computed,
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [])
], AccountLinkingViewModel.prototype, "isLoading", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], AccountLinkingViewModel.prototype, "flipLongPressLoginButton", null);
